import React from "react";
import { IPlayerSearchResponse } from "../../types/IPlayerSearchResponse";
import CustomList from "../../ui/CustomList";
import GlobalSearchItem from "./GlobalSearchItem";

interface ISearchClubProps {
  searchData: any[];
  searchText: string;
  onSelect?: (item: IPlayerSearchResponse | IPlayerSearchResponse[] | null, selected: boolean) => void;
  selectedItems?: IPlayerSearchResponse[];
  multiSelection?: boolean;
  iconType: string;
  displayCheckBox?: boolean;
  ifEntireNameHiglight?: boolean;
  fromHomePage?:boolean;
}

const GlobalSearchList: React.FC<ISearchClubProps> = ({
  searchData,
  searchText,
  onSelect,
  selectedItems,
  multiSelection,
  iconType,
  displayCheckBox,
  ifEntireNameHiglight,
  fromHomePage
}) => {
  return (
    <CustomList<IPlayerSearchResponse>
      selectedItems={selectedItems}
      onSelect={onSelect}
      multiSelection={multiSelection}
      isCheckBox={displayCheckBox}
      showSelectAllCheckbox={false}
      isGlobalSearch={true}
      isMaxWidth={false}
    >
      {searchData.map((search) => {
        return (
          <GlobalSearchItem
            key={search.id}
            item={search}
            searchText={ifEntireNameHiglight ? search?.name : searchText}
            iconType={iconType}
            fromHomePage={fromHomePage}
          />
        );
      })}
    </CustomList>
  );
};

export default GlobalSearchList;
